import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import TimeFormatter from '../../utils/TimeFormatter/TimeFormatter';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';
import InlineInput from '../InlineInput/InlineInput';

export default class DateDisplay extends React.Component<DateDisplayProps, {}> {
   constructor(props: DateDisplayProps) {
      super(props);
      autoBind(this);
   }

   removeDate(e: any) {
      e.stopPropagation();
      this.props.removeDate();
   }

   render() {
      const {value, themeName, innerRef, onClick} = this.props;
      const text = value ? `${Strings.labels.reviewDeadlinePrefix} ${TimeFormatter.getReviewByDateAdjustedFromLocalTimezone(value)}` : Strings.defaults.deadlinePlaceholder;
      const dateButton = <ControlButton themeName={themeName} buttonType={TscButtonType.secondary} label={text} onClick={onClick} ref={innerRef}/>;
      const deleteDateButton = value && <ControlButton title={Strings.labels.startReviewModal.reviewDetails.deadline.removeTitle}
                                              themeName={themeName}
                                              buttonType={TscButtonType.secondary}
                                              glyph={<Glyphs.CircleRemove16x16/>}
                                              onClick={this.removeDate}
                                              testId="review-details-deadline-delete-button"/>;

      return (
         <InlineInput middleComponent={dateButton} rightComponent={deleteDateButton}/>
      );
   }
}

interface DateDisplayProps extends Themeable {
   value?: Date;
   innerRef(ref: any): void;
   onClick(): void;
   removeDate(): void;
}
